export default {"src":"/_next/static/media/hot-tub.1d3b1c5f.svg","height":32,"width":31,"blurWidth":0,"blurHeight":0};